import { BlockText, GridContainer, GridItem, ViewSection } from "@duosoftbg/nacid-components";
import React from "react";
import { useTranslation } from "react-i18next";

const AccountDataSection = ({ user }) => {
  const { t } = useTranslation();

  return (
    <ViewSection label={"t.registration.details"}>
      <GridContainer spacing={5} mt={0}>
        <GridItem>
          <BlockText label={"l.user.username"} text={user.username} />
        </GridItem>
        <GridItem>
          <BlockText label={"l.user.email"} text={user.email} />
        </GridItem>
        <GridItem>
          <BlockText label={"l.user.emailVerified"} text={user.emailVerified ? t("l.yes") : t("l.no")} />
        </GridItem>
      </GridContainer>
    </ViewSection>
  );
};
export default AccountDataSection;
